<script>
import { mapGetters } from "vuex";
import CoursesCategoryCard from "./CoursesCategoryCard.vue";

export default {
  name: "CoursesCategories",
  components: {
    CoursesCategoryCard,
  },
  props: {
    parentOnly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedParentId: null,
    };
  },
  computed: {
    ...mapGetters(["coursesCategories"]),
    filteredCoursesCategories() {
      if (this.selectedParentId) {
        return this.coursesCategories?.filter((item) => item.parent_id === this.selectedParentId);
      }
      if (this.parentOnly) {
        return this.coursesCategories?.filter((item) => item.parent_id === null);
      }
      return this.coursesCategories;
    }
  },
  methods: {
    onSelect(category) {
      const existChildren = this.coursesCategories.find((item) => item.parent_id === category.id);

      if (!existChildren) {
        return this.$router.push({ name: 'allCoursesPage', params: { categorySlug: category.slug } })
      }

      this.selectedParentId = category.id;

    }
  }
}
</script>

<template>
  <div class="courses-categories">
    <div class="courses-categories-list">
      <CoursesCategoryCard v-for="category in filteredCoursesCategories" :key="category.id" v-bind="category"
        class="content-filling-element" @click="onSelect(category)">
        {{ category.name }}
      </CoursesCategoryCard>
    </div>
  </div>
</template>

<style>
.courses-categories {
  max-width: 1100px;
  width: 100%;

}

.courses-categories-list {
  display: grid;
  margin-top: 24px;
  gap: 20px;

  grid-template-columns: repeat(2, 1fr);
}

@media(max-width:786px) {
  .courses-categories__title {
    font-size: 24px;
  }

  .courses-categories-list {
    display: grid;
    gap: 20px;
    max-width: 1100px;
    grid-template-columns: repeat(1, 1fr);
  }
}

.fade-list-enter-active,
.fade-list-leave-active {
  transition: 200ms ease;
}

.fade-list-enter-from,
.fade-list-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

.fade-list-move {
  transition: transform 200ms ease;
}
</style>
